import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserInfo } from 'src/app/models/user-state.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly http = inject(HttpClient);

  getUserInfo(): Observable<UserInfo> {
    return this.http.get<UserInfo>(`${environment.ARP_API}user/info/`, {
      headers: new HttpHeaders({
        'no-default-interceptor': 'true'
      })
    });
  }
}
